import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ScheduleResume from './ScheduleResume';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Slide from './Slide';
import Styles from '../styles/AppIndex.module.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Helper from './Helper';
import { updatePaymentStatusByUser } from '../utils/database';
import { useEffect } from 'react';

export default function AppIndex(props) {

    const navigate = useNavigate()

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
    };

    const updateUserStatus = async () => {
        const result = await updatePaymentStatusByUser(props.userMenu.userid)

        if (result.type !== props.userMenu.plan.type) {
            props.updateUserData()
        }
    }

    useEffect(() => {
        updateUserStatus()
    }, [])

    if (!props.userMenu) {
        return null

    } else {
        return (
            <Stack
                justifyContent='flex-start'
                alignItems='flex-start'
                flexWrap='wrap'
                spacing={2}
            >

                <Typography variant='h3'>
                    {props.userMenu.title}
                </Typography>

                <Stack direction='row' spacing={2} alignItems='flex-start' justifyContent='center'>
                    <Typography variant='h5'>
                        Tu comercio se encuentra: {props.userMenu.disabled ?
                            <span className={`${Styles.storeDisabled} ${Styles.storeState}`}>DESACTIVADO</span> :
                            <span className={`${Styles.storeActive} ${Styles.storeState}`}>ACTIVO</span>}
                    </Typography>

                    <Typography variant='h5'>
                        Tu plan es: {props.userData.plan.type === 'free' ?
                            <span className={`${Styles.freePlan} ${Styles.storeState}`}>GRATUITO</span> :
                            <span className={`${Styles.proPlan} ${Styles.storeState}`}>PRO</span>}
                    </Typography>

                    <Helper text='Los cambios en tu plan pueden tardar hasta 5 minutos en actualizarse al recargar la pagina' />
                </Stack>

                <Divider sx={{ width: '100%', m: 1 }} />

                <Typography variant='h4'>
                    Consejos
                </Typography>

                <Slider {...settings} style={{ width: '100%', maxWidth: '75vw', margin: '15px auto 25px auto' }}>

                    {props.userMenu.phoneNumber === '' ?
                        <Slide
                            severity='warning'
                            title='Importante (Numero para pedidos)'
                            content='Parece que aún no tienes un numero de telefono para recibir los pedidos por whatsapp y debés tener uno para poder recibir pedidos, puedes
                            configurarlo en "Información del negocio"'
                            key={8}
                        /> : null}

                    {props.userMenu.title !== '' ? null :
                        <Slide
                            severity={'warning'}
                            title='Recomendación (Nombre comercio)'
                            content='Deberías elegir un nombre para tu comercio, de esta forma tus clientes van a poder reconocer tu marca de una forma mas rapida,
                            puedes hacerlo desde la sección "Modificar menu"'
                            key={1}
                        />}

                    {props.userMenu.description !== '' ? null :
                        <Slide
                            severity={'warning'}
                            title='Recomendación (Descripción comercio)'
                            content='Deberías incluir una descripción de tu comercio en tu menú, puedes describirlo brevemente e indicar cuales son sus especialidades,
                            puedes hacerlo desde la sección "Modificar menu"'
                            key={2}
                        />}

                    {!props.userMenu.paymentOptions || props.userMenu.paymentOptions.length === 0 ?
                        <Slide
                            severity='warning'
                            title='Recomendación (Metodos de pago)'
                            content='Parece que aún no indicaste los medios de pago aceptados por tu negocio, configurar esto permite que tus clientes sepan y puedan indicar 
                            previamente como desean completar el pago para luego poder finalizarlo contigo por WhatsApp. Puedes hacerlo desde la sección "Información del negocio"'
                            key={3}
                        /> : null}

                    {!props.userMenu.deliveryOptions || props.userMenu.deliveryOptions.length === 0 ?
                        <Slide
                            severity='warning'
                            title='Recomendación (Formas de entrega)'
                            content='Parece que aún no indicaste las formas de entrega aceptadas por tu negocio, configurar esto permitirá a tus clientes indicar que metodo de entrega prefieren.
                            Puedes hacerlo desde la sección "Información del negocio"'
                            key={4}
                        /> : null}

                    <Slide
                        severity='normal'
                        title='Recuerda que puedes crear promociones'
                        content='Puedes crear promociones que afecten determinados productos y que solo estén activas en determinados dias y horarios. Puedes crearlas desde
                        la sección "Modificar menu"'
                        key={5}
                    />

                    <Slide
                        severity='normal'
                        title='Recuerda que puedes destacar tus productos'
                        content='Editando cada producto puedes hacer click en la estrella para destacarlo. Los productos destacados se muestran primeros en tu menu'
                        key={6}
                    />

                    <Slide
                        severity='normal'
                        title='Puedes crear mensajes para tus clientes'
                        content='Dentro de la sección "Modificar menu" puedes crear un mensaje para tus usuarios que se muestre solo en determinados dias y horarios. 
                        Puedes usarlo para informalos acerca de cosas que consideres relevantes.'
                        key={7}
                    />

                </Slider>

                <Divider sx={{ width: '100%', m: 1 }} />

                <Typography variant='h4'>
                    Resumen de tu comercio
                </Typography>

                <Stack direction='row' flexWrap='wrap'>
                    <Card sx={{ flexGrow: '1', m: 1 }}>
                        <CardContent>
                            <Typography variant='h5'>
                                Promociones activas
                            </Typography>

                            {!props.userMenu.offers ? null :
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }} component="nav">
                                    {props.userMenu.offers.map((offer, index) => {
                                        return (
                                            <div key={index}>
                                                <ListItemText primary={offer.name} />
                                                <Divider />
                                            </div>
                                        )
                                    })}
                                </List>
                            }
                        </CardContent>
                        <CardActions>
                            <Button size="small" onClick={navigate.bind(this, '/admin/app/menudata')} >Modificar promociones</Button>
                        </CardActions>
                    </Card>

                    <Card sx={{ flexGrow: '1', m: 1 }}>
                        <CardContent>
                            <Typography variant='h5'>
                                Horarios de atención
                            </Typography>

                            {!props.userMenu.schedule.delivery.reduce((prev, curr) => curr.active || prev, false) ? null :
                                <>
                                    <Typography variant='h6'>Delivery</Typography>
                                    <ScheduleResume schedule={props.userMenu.schedule.delivery} />
                                </>}

                            {!props.userMenu.schedule.takeaway.reduce((prev, curr) => curr.active || prev, false) ? null :
                                <>
                                    <Typography variant='h6'>Takeaway</Typography>
                                    <ScheduleResume schedule={props.userMenu.schedule.takeaway} />
                                </>}


                        </CardContent>
                    </Card>

                    <Card sx={{ flexGrow: '1', m: 1 }}>
                        <CardContent>
                            <Typography variant='h5'>
                                Mensaje para los clientes actual
                            </Typography>

                            <Divider sx={{ m: 1 }} />

                            <b>Mensaje: </b> {props.userMenu.message.msg}

                            <Divider sx={{ m: 1 }} />

                            <b>Horarios</b>

                            <ScheduleResume schedule={props.userMenu.message.schedule} />
                        </CardContent>
                        <CardActions>
                            <Button size="small" onClick={navigate.bind(this, '/admin/app/menudata')} >Modificar mensaje y horarios</Button>
                        </CardActions>
                    </Card>


                    <Card sx={{ flexGrow: '1', m: 1 }}>
                        <CardContent>
                            <Typography variant='h5'>
                                Productos destacados
                            </Typography>

                            {!props.userMenu.products ? null :
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }} component="nav">
                                    {Object.values(props.userMenu.products)
                                        .filter(product => product.featured)
                                        .map((product, index) => {
                                            return (<div key={index}>
                                                <ListItemText primary={product.name} />
                                                <Divider />
                                            </div>)
                                        })}
                                </List>}

                        </CardContent>
                        <CardActions>
                            <Button size="small" onClick={navigate.bind(this, '/admin/app/products')} >Editar productos</Button>
                        </CardActions>
                    </Card>
                </Stack>


                <Divider sx={{ width: '100%', m: 1 }} />

                <Typography variant='h4'>
                    Preguntas frecuentes
                </Typography>

                <Typography variant="h5" >Version PRO</Typography>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel1a-header"
                    >
                        <Typography>Como puedo conseguir la versión PRO de Tookeat?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            ¡Haz crecer tu negocio al siguiente nivel con la versión PRO de TooKeat! Desbloquea todas las funciones disponibles para impulsar tu éxito empresarial al contratar
                            nuestro plan PRO. Dirígete a la sección 'Planes Pagos' para obtener información detallada y descubrir cómo nuestras herramientas pueden potenciar tu negocio.
                            La suscripción se realiza de forma sencilla y segura a través de MercadoPago
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel2a-header"
                    >
                        <Typography>Como funciona la prueba gratis de la versión PRO?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Crea una cuenta de manera rápida y totalmente gratuita, y accede a una amplia selección de funciones de TooKeat para potenciar tu negocio
                            (ten en cuenta que no todas las funciones están disponibles en la versión de prueba gratuita). Además, podrás realizar ventas en línea y publicar hasta 10 productos.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel3a-header"
                    >
                        <Typography>Como puedo cancelar mi suscripción a la versión PRO?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Si deseas cancelar tu suscripción a la versión PRO de TooKeat, simplemente ingresa a tu cuenta de MercadoPago y dirígete a la sección de suscripciones.
                            Una vez allí, encontrarás la opción para cancelar tu suscripción mensual. Ten en cuenta que si cancelas dentro de los primeros 15 días de la prueba gratuita, no se te cobrará ningún cargo.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel4a-header"
                    >
                        <Typography>Que dia se cobrará mi suscripción a la versión PRO de Tookeat?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            El día en el que se te cobrará por tu suscripción al plan de TooKeat dependerá de la frecuencia de pago que hayas seleccionado.
                            En el caso de la frecuencia mensual, se realizará el primer cobro después de la activación de la suscripción y luego se te cobrará cada 30 días a partir de esa fecha.
                            Para los planes anuales, el primer cobro se realizará al activar la suscripción y, posteriormente, se te cobrará cada 365 días.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Divider sx={{ m: 2 }} />

                <Typography variant="h5" >Productos</Typography>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel5a-header"
                    >
                        <Typography>Como agregar un producto?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Debes ir a la sección "Productos" en el menú y luego tocar el botón "Crear un nuevo producto".
                            A cada producto debes elegirle un nombre y una categoria de forma obligatoria, tambien puedes destacarlo, asignarle un precio e indicar sus calorias aproximadas.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel6a-header"
                    >
                        <Typography>Que son las versiones o extras?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Cada producto que crees puede tener varias versiones o extras. Por ejemplo puedes crear una versión que sea "bebida" y que el cliente elija una opción para acompañar su pedido.
                            Otro caso de uso es el ofrecer "extras", por ejemplo que tu cliente pueda agregar unidades de carne extra con su hamburguesa.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Divider sx={{ m: 2 }} />

                <Typography variant="h5" >Personalización</Typography>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel7a-header"
                    >
                        <Typography>Que puedo personalizar de mi menu online?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Puedes elegir un color que se va a utilizar en algunos aspectos del menú, también puedes elegir un logo y una imagen de portada para tu menú.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Divider sx={{ m: 2 }} />

                <Typography variant="h5" >Administrar tu negocio</Typography>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        id="panel8a-header"
                    >
                        <Typography>Que es el identificador de comercio?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Es un identificador unico por comercio, ese mismo va a decidir como va a ser el link a tu menú. Recuerda que siempre que lo cambies todos tus links a tu menú van a ser diferentes y deberás actualizarlos.
                            Por ejemplo si tienes tu link en tu pagina de instagram deberás actualizarlo ahí.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Stack >
        )
    }
}

